import SEPUTARLMB from "../../assets/medPart/value/seputarlombaid.png";
import LOMBAMHS from "../../assets/medPart/value/lombamahasiswa.png";
import RNB from "../../assets/medPart/value/rnb.png";
import ACARAJTM from "../../assets/medPart/value/acarajatim.png";
import EJT from "../../assets/medPart/value/ejt.png";
import OPCIT from "../../assets/medPart/value/optimasicinta.png";
import AM from "../../assets/medPart/value/am.png";
import UIN from "../../assets/medPart/value/uin.png";
import BEMVOKASI from "../../assets/medPart/value/bemvokasi.png";
import MHLGLM from "../../assets/medPart/value/mhlglm.png";
import WS from "../../assets/medPart/value/ws.png";
import KANAL24 from "../../assets/medPart/value/kanal24.png";
import INFOSMNR from "../../assets/medPart/value/seminarinfo.png";
import UBTV from "../../assets/medPart/value/ubtv.png";
import UBRADIO from "../../assets/medPart/value/ubradio.png";
import POLSET from "../../assets/medPart/value/polinema.png";
import LOMBAMHS2 from "../../assets/medPart/value/lombamahasiswa2.png";
import SEMINARCNTR from "../../assets/medPart/value/sc.png";
import SEPUTARINFO from "../../assets/medPart/value/si.png";
import BFAST from "../../assets/medPart/value/bfast.png";
//sponsor
import APBS from "../../assets/sponsor/apbs.png";
import CHICKIN from "../../assets/sponsor/chickin.png";
import TELKOM from "../../assets/sponsor/telkom.png";
import NUTRIHUB from "../../assets/sponsor/nutrihub.png";
import LARISSA from "../../assets/sponsor/larissa.png";
import LAPISKUKUS from "../../assets/sponsor/lapisKukus.png";
import METEOR from "../../assets/sponsor/meteor.png";
import PARAGON from "../../assets/sponsor/paragon.png";
import KAHF from "../../assets/sponsor/kahf.png";
import DECHICKEN from "../../assets/sponsor/deChicken.png";
import ISOIRESIK from "../../assets/sponsor/isoiresik.png";
import EMINA from "../../assets/sponsor/emina.png";
import SGROUP from "../../assets/sponsor/secretGroup.png";
import KAMERAMALANG from "../../assets/sponsor/kameraMalang.png";
import SUSU from "../../assets/sponsor/fFlag.png";
import BARAKAHAYYU from "../../assets/sponsor/barakaHayyu.png";

export const mediaPartner = [
  { image: SEPUTARLMB, alt: "Seputar Lomba", className: "" },
  { image: LOMBAMHS, alt: "Lomba Mahasiswa", className: "" },
  { image: RNB, alt: "RnB", className: "" },
  { image: ACARAJTM, alt: "Acara Jatim", className: "" },
  { image: EJT, alt: "Event Jawa Timur", className: "" },
  { image: OPCIT, alt: "Optimasi Cinta", className: "" },
  { image: AM, alt: "Acara Mahasiswa", className: "" },
  { image: UIN, alt: "UIN Maliki Story", className: "" },
  { image: BEMVOKASI, alt: "BEM Vokasi", className: "" },
  { image: MHLGLM, alt: "Mahasiswa Ngalam", className: "" },
  { image: WS, alt: "Web Seminar", className: "" },
  { image: KANAL24, alt: "Kanal 24", className: "" },
  { image: INFOSMNR, alt: "Info Seminar", className: "" },
  { image: UBTV, alt: "UB TV", className: "" },
  { image: UBRADIO, alt: "UB Radio", className: "" },
  { image: POLSET, alt: "Polinema Story", className: "" },
  { image: LOMBAMHS2, alt: "Lomba Mahasiswa", className: "" },
  { image: SEMINARCNTR, alt: "Seminar Center", className: "" },
  { image: SEPUTARINFO, alt: "Seputar Info", className: "" },
  { image: BFAST, alt: "B-Fast", className: "" },
];

export const sponsor = [
  {
    image: APBS,
    alt: "APBS",
    className: "mx-auto col-span-1 lg:col-span-3 scale-80 lg:scale-75 lg:ml-20",
  },
  {
    image: undefined,
    alt: "",
    className: "mx-auto col-span-1 hidden lg:block",
  },
  {
    image: CHICKIN,
    alt: "Chickin",
    className: "mx-auto col-span-1 lg:col-span-3 scale-75 lg:scale-90 lg:pr-44",
  },
  { image: TELKOM, alt: "Telkom Indonesia", className: "" },
  { image: NUTRIHUB, alt: "Nutrihub Malang", className: "" },
  { image: LARISSA, alt: "Larissa", className: "" },
  { image: LAPISKUKUS, alt: "Lapis Kukus Malang", className: "" },
  { image: METEOR, alt: "Meteor", className: "" },
  { image: PARAGON, alt: "Paragon", className: "" },
  { image: KAHF, alt: "Kahf", className: "" },
  { image: DECHICKEN, alt: "De Chicken", className: "" },
  { image: ISOIRESIK, alt: "Osioresik Cleaning", className: "" },
  { image: EMINA, alt: "Emina", className: "" },
  { image: BARAKAHAYYU, alt: "Baraka & Hayyu", className: "scale-75" },
  { image: SGROUP, alt: "Secret Group", className: "" },
  { image: KAMERAMALANG, alt: "Kamera Malang", className: "" },
  { image: SUSU, alt: "Frisian Flag", className: "" },
];
